import React, { useEffect, useState } from "react";
import { Divider, Form, Grid, GridColumn, GridRow, Segment, SegmentGroup } from "semantic-ui-react";
import { useAgeReadyContext } from "../../../AgeReadyContext/AgeReadyContext";
import FileUpload from "./FileUpload";
import styles from "./Documents.module.css"
import DocumentTable from "./DocumentTable";

interface DocumentLibraryProps {
  domain: string;
  caregiverId: string;
  recipientId: string;
  recipientName: string;
}

export const DocumentLibrary: React.FC<DocumentLibraryProps> = (props) => {
  const { domain, caregiverId, recipientId, recipientName } = props;
  const { documentInfoStore } = useAgeReadyContext();

  const [ isFileUploading, setIsFileUploading] = useState(false);
  const [ tableButtonLoading, setTableButtonLoading] = useState("");
  const [ docInfoItems, setDocInfoItems] = useState<Array<any>>([ { documentId: '', caregiverId: caregiverId, recipientId: recipientId, 
    fileName: 'No documents to view', fileType: '', uploadedOn: '', domain: '', tasks: ''}]);


  // eslint-disable-next-line
  useEffect(() => { refreshTable(); }, [] );

  useEffect( () => { 
    setDocInfoItems(documentInfoStore.infoItems);
  }, [documentInfoStore.infoItems, documentInfoStore.infoItems.length, docInfoItems])

  const refreshTable = async () => {
    await documentInfoStore.loadTableDataByRecipientId(recipientId);

    setDocInfoItems(documentInfoStore.infoItems);
    setIsFileUploading(false);
  };

  const setFileUploadingStatus = (isUploading: boolean) => {
    setIsFileUploading(isUploading);
  };

  const setTableBtnLoading = (btn: string) => {
    setTableButtonLoading(btn);
  }

  const downloadDocument = async (docId: string, docName: string, caregiverId: string, recipientId: string) => {
    await documentInfoStore.downloadDocument(docId, docName, caregiverId, recipientId);
    setTableButtonLoading("");
  };

  const deleteDocument = async (docId: string, docName: string, caregiverId: string, recipientId: string) => {
    await documentInfoStore.deleteDocument(docId, docName, caregiverId, recipientId);
    setTableButtonLoading("");
  };

  return (
    <>
      <Grid columns='equal' stackable id={styles.docLibGrid}>
        <GridRow stretched className={styles.docLibFullSpace}>
          <GridColumn width={6}>
            <SegmentGroup raised className={styles.docLibUploadGroupBG}>
              <Segment basic className={styles.docLibUploadBG} >                
                <Segment raised className={styles.docLibUploadSeg} >               
                  <Divider horizontal><p>ADD A NEW DOCUMENT</p></Divider>
                  <Form>
                    <FileUpload label=" "
                      caregiverId={caregiverId}  id="fileUploadId" 
                      domain={domain} task="TASK1" 
                      recipientId={recipientId} recipientName={recipientName} 
                      isUploading={isFileUploading} 
                      setIsUploading={(isUploading: boolean) => setFileUploadingStatus(isUploading)}
                      refreshDocTableData={refreshTable} />
                  </Form>
                </Segment>
              </Segment>
            </SegmentGroup>
          </GridColumn>
          <GridColumn stretched>
            <Segment basic id={styles['document-view']}>
              <Divider horizontal><p>DOCUMENTS</p></Divider>
             
              <DocumentTable 
                docInfoItems={docInfoItems} tableHeaders={documentInfoStore.tableHeaders} 
                loadingBtn={tableButtonLoading}
                setTableBtnLoading={(btn: string) => setTableBtnLoading(btn)}
                deleteDoc={deleteDocument}
                downloadDoc={downloadDocument}/>
            </Segment>
          </GridColumn>
        </GridRow>
      </Grid>
    </>
  );
};